import moment from "moment"
import { path, pathOr, T, F, cond } from "ramda"
import {
  isStudent,
  isAssociate,
  isQualifierEligible,
  isMember,
  isTerminated,
} from "../utils"
import { TERMINATE_CODE } from "./terminateCodes"

// University (Grad): 4 months from terminateDate, then lose access.
const allowFourMonthsAccess = me => {
  const terminateDate = path(["termination", "terminateDate"], me)
  const fourMonthsFromTermDate = moment(terminateDate).add(4, "month")
  return !moment(fourMonthsFromTermDate).isAfter(moment())
}

const termCodeRules = {
  [TERMINATE_CODE.ACCEPTABLE_PROGRESS]: {
    forTypes: ["AP", "QE"],
    predicateFn: F,
  },
  [TERMINATE_CODE.UNIVERSITY_GRAD]: {
    forTypes: ["ST"],
    predicateFn: allowFourMonthsAccess,
  },
}

/** Live program type first; fall back to type-at-termination only when live type is missing. */
const programTypeForTerminationRules = me => {
  const liveType = me?.mainProgramTypeCode || me?.type
  if (liveType) return liveType

  const terminationType = path(["termination", "type"], me)
  return terminationType === "AF" ? "AP" : terminationType
}

// predicate function returns false if user is allowed access to dashboard
const isTerminatedByCodes = me => {
  const terminateCd = path(["termination", "terminateCd"], me)
  const termCodeRule = pathOr({}, [terminateCd], termCodeRules)
  const programType = programTypeForTerminationRules(me)
  if (termCodeRule.forTypes && termCodeRule.forTypes.includes(programType)) {
    return termCodeRule.predicateFn(me)
  }
  return true
}

export default cond([
  [isStudent, isTerminatedByCodes],
  [isAssociate, isTerminatedByCodes],
  [isQualifierEligible, isTerminatedByCodes],
  [isMember, isTerminatedByCodes],
  [isTerminated, isTerminatedByCodes],
  [T, F],
])
